import { Copy, Download } from "lucide-react";
import { IconButton } from "@/components/ui/Button";
import Menu from "@/components/ui/Menu";

// The report's actions in the page header: copying and downloading the image,
// used often, sit beside the round More button, which holds the CSV, the
// remembered view, and a refresh of the dates on screen.
export default function MediaPerformanceActionsMenu({
  onCopyImage,
  onDownloadImage,
  imageBusy = false,
  onDownloadCsv,
  onRefresh,
  downloading = false,
  refreshing = false,
  canRefresh = false,
  onSaveDefault,
  onResetDefault,
  defaultBusy,
}: {
  onCopyImage?: () => void;
  onDownloadImage?: () => void;
  imageBusy?: boolean;
  onDownloadCsv?: () => void;
  onRefresh?: () => void;
  downloading?: boolean;
  refreshing?: boolean;
  canRefresh?: boolean;
  onSaveDefault?: () => void;
  onResetDefault?: () => void;
  defaultBusy?: boolean;
}) {
  const view = Boolean(onSaveDefault || onResetDefault);
  return (
    <>
      {onCopyImage ? (
        <IconButton aria-label="Copy image" disabled={imageBusy} onClick={onCopyImage}>
          <Copy size={16} />
        </IconButton>
      ) : null}
      {onDownloadImage ? (
        <IconButton aria-label="Download image" disabled={imageBusy} onClick={onDownloadImage}>
          <Download size={16} />
        </IconButton>
      ) : null}
      <Menu
        aria-label="More report actions"
        items={[
          onDownloadCsv && {
            label: downloading ? "Preparing CSV…" : "Download CSV",
            disabled: downloading,
            onSelect: onDownloadCsv,
          },
          onDownloadCsv && view && { separator: true },
          onSaveDefault && { label: "Save view", disabled: defaultBusy, onSelect: onSaveDefault },
          onResetDefault && {
            label: "Reset view",
            disabled: defaultBusy,
            onSelect: onResetDefault,
          },
          canRefresh && onRefresh && (onDownloadCsv || view) && { separator: true },
          canRefresh &&
            onRefresh && {
              label: refreshing ? "Refresh in progress…" : "Refresh current view",
              disabled: refreshing,
              onSelect: onRefresh,
            },
        ]}
      />
    </>
  );
}
